export const COURSE_IMAGES = {
  hero: '/images/hero-ai-engineering.png',
  programHero: '/images/highlights-team.png',
  interviewHero: '/images/selection-assessment.png',
  selection: '/images/selection-assessment.png',
  highlights: '/images/highlights-team.png',
  curriculum: '/images/curriculum-learning.png',
  tools: '/images/tools-workspace.png',
  career: '/images/career-mentoring.png',
  programsHero: '/images/programs-hero.png',
  coursesHero: '/images/curriculum-learning.png',
  courseCard: '/images/curriculum-learning.png',
  projectsHero: '/images/highlights-team.png',
  labsHero: '/images/tools-workspace.png',
  eventsHero: '/images/highlights-team.png',
  loginPanel: '/images/idschool-login-panel.png',
} as const;
